module.exports = __webpack_public_path__ + "static/img/Planificaciones_9_pruébala gratis 2@4x.4892a80b.png";